/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ErrorWrap } from "./ErrorWrap";
import { LoaderWrap } from "./LoaderWrap";

type ErrorWrapProps = React.ComponentProps<typeof ErrorWrap>;
type LoaderWrapProps<T = Record<string, never>> = React.ComponentProps<
  typeof LoaderWrap<T>
>;

type Props<LoaderProps> = {
  children: React.ReactNode;
  loaderProps: Omit<LoaderWrapProps<LoaderProps>, "children">;
  errorProps: ErrorWrapProps;
};

export function UniversalWrap<LoaderProps = Record<string, unknown>>({
  children,
  loaderProps,
  errorProps,
}: Props<LoaderProps>) {
  return (
    <LoaderWrap {...loaderProps}>
      <ErrorWrap {...errorProps}>{children}</ErrorWrap>
    </LoaderWrap>
  );
}
